<template>
  <MUIDialog
    class="mui-dialog--scale-recipe"
    data-html2canvas-ignore="true"
    :actionItem="actionItem"
    :acceptItem="acceptItem"
    :displayType="displayType"
    :scrollable="true"
    title="Scale recipe"
    ref="dialog">
    <div class="mui-form mui-dialog--scale-recipe__form">
      <div class="form-group field-text">
        <div class="field-wrap">
          <input
            @keyup.enter="complete"
            class="form-control"
            min="0"
            max="1000"
            name="scale"
            placeholder="Scale"
            ref="input"
            type="number"
            v-model.trim="suggestedScale" />
        </div>
      </div>
      <div class="mui-dialog--scale-recipe__options" role="menu" aria-hidden="true">
        <MUIChip
          v-for="(option, index) in options"
          :key="index"
          :active="toFraction(option) === toFraction(suggestedScale)"
          role="menuitem"
          @click.native="setScale(option)">
          {{toFraction(option)}}
        </MUIChip>
      </div>
    </div>
  </MUIDialog>
</template>

<script>
import { mapGetters } from 'vuex'

import { scaleToString, validateScale } from '@/models/scale'

import MUIChip from '@/components/MUIChip'
import MUIDialog from '@/components/MUIDialog'

import { APP } from '@/config'

export default {
  components: {
    MUIDialog,
    MUIChip
  },
  props: {
    scale: {
      required: true,
      type: String
    },
    selectHandler: {
      required: true,
      type: Function
    }
  },
  computed: {
    ...mapGetters([
      'isSizeClassCompact'
    ]),
    actionItem () {
      if (this.scale === '1') return {}
      return {
        id: 'reset_scale',
        fn: () => { this.setScale('1') },
        icon: 'cached',
        name: 'Reset'
      }
    },
    acceptItem () {
      return {
        icon: this.isSizeClassCompact ? 'done' : null,
        name: 'Done',
        fn: () => { this.complete() }
      }
    }
  },
  data () {
    return {
      suggestedScale: parseFloat(this.$props.scale),
      options: [
        '0.25',
        '0.333',
        '0.5',
        '0.667',
        '0.75',
        '1',
        '1.5',
        '2',
        '3',
        '4',
        '5'
      ],
      displayType: APP
    }
  },
  methods: {
    complete () {
      this.setScale(this.suggestedScale)
    },
    setScale (option) {
      this.suggestedScale = validateScale(option)
      this.selectHandler(this.suggestedScale)
      this.$refs.dialog.close()
    },
    toFraction (scale) {
      return scaleToString(scale)
    }
  },
  mounted () {
    this.$refs.input.focus()
  }
}
</script>

<style lang="sass" scope>
.mui-dialog.mui-dialog--scale-recipe
  .device__viewport-class--regular &
    width: 360px
.mui-dialog--scale-recipe__form
  padding-top: 8px
  width: 100%
  .form-control
    font-size: 24px
    font-weight: 500
    text-align: center
  .mui-dialog--scale-recipe__options
    margin-top: 32px
    text-align: center
    .mui-chip__text
      font-weight: normal
      font-size: 16px
      line-height: 1
</style>



// WEBPACK FOOTER //
// src/views/ScaleDialog.vue